<!-- 利用開始日に関する注意文 -->
<template>
  <div>
    <!-- ※1ヶ月後の日付まで選択できます 等の注意書き -->
    <p class="help-block" v-html="newlineConvert(note)" />
  </div>
</template>

<script>
export default {
  name: "MbPurchaseStartedatCaution",
  props: {
    note: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.help-block {
  margin: 10px 0 10px 0 !important;
  font-size: 13px !important;
  text-align: left;
  line-height: 17px;
  white-space: pre-wrap;
}
</style>
